import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import Breadcrumb from 'sushiweb/Breadcrumb/Breadcrumb';
import H5 from 'sushiweb/Typography/Heading/H5';
import grey from 'sushiweb/tokens/color/grey';
import { questionsHeadColumn } from '../common/components/DataTables/components/headColumns';
import {
  BreadcrumbHeaderWrapper,
  BreadCrumbWrapper,
  DashboardWrapper,
  TableContainerWithOverflow,
  TabWrapper,
} from '../common/styles';
import ErrorPage from '../common/components/ErrorPage';
import { REFRESH_LABEL } from '../common/components/constants';
import DataTables from '../common/components/DataTables';
import { DASHBOARD_ROUTE, HOME_ROUTE } from '../../constants/routes';
import { TableHeaderWrapper } from '../Payments/styles';

const Questions = ({
  selectedWorkspace,
  questions,
  fetchingQuestions,
  fetchedQuestions,
  getAllQuestions,
}) => {
  const { questionsData = [] } = questions;
  const [loading, setLoading] = useState(true);
  const [currentData, setCurrentData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id) {
      getAllQuestions({ workspaceId: selectedWorkspace.workspace_id });
    }
  }, [selectedWorkspace]);

  useEffect(() => {
    if (!fetchingQuestions) {
      const data = questionsData || [];
      setSearchResults(data);
      setCurrentData(data.slice(0, 10));
      setLoading(false);
    }
  }, [fetchingQuestions]);

  useEffect(() => {
    if (searchResults) {
      const start = (currentPage - 1) * 10;
      const end = currentPage * 10;
      setCurrentData(searchResults.slice(start, end));
    }
  }, [currentPage, searchResults]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const refreshPage = () => {
    getAllQuestions({ workspaceId: selectedWorkspace.workspace_id });
  };

  return (
    <DashboardWrapper>
      <BreadcrumbHeaderWrapper>
        <BreadCrumbWrapper>
          <Breadcrumb>
            <Breadcrumb.Link
              style={{ color: 'var(--coolgreycoolgrey-400, #AFB4C0)' }}
              linkTo={`${DASHBOARD_ROUTE}#${HOME_ROUTE}`}
            >
              Home
            </Breadcrumb.Link>
            <Breadcrumb.Link
              style={{ color: 'var(--coolgreycoolgrey-800, #414A5D)' }}
            >
              Questions
            </Breadcrumb.Link>
          </Breadcrumb>
        </BreadCrumbWrapper>
      </BreadcrumbHeaderWrapper>
      <TableHeaderWrapper>
        <H5>Business Order Details</H5>
      </TableHeaderWrapper>
      <TabWrapper>
        <TableContainerWithOverflow
          style={{ borderRadius: '20px', border: `0.1rem solid ${grey.z100}` }}
        >
          {!fetchedQuestions ? (
            <ErrorPage
              showAction
              actionLabel={REFRESH_LABEL}
              clickAction={refreshPage}
            />
          ) : (
            <DataTables
              columns={questionsHeadColumn}
              loading={fetchingQuestions || loading}
              data={currentData}
              pagination
              totalRows={searchResults.length}
              handlePageChange={handlePageChange}
              emptyStateTitle='No questions found'
            />
          )}
        </TableContainerWithOverflow>
      </TabWrapper>
    </DashboardWrapper>
  );
};

Questions.propTypes = {
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  questions: PropTypes.objectOf(PropTypes.any),
  fetchingQuestions: PropTypes.bool,
  fetchedQuestions: PropTypes.bool,
  getAllQuestions: PropTypes.func,
};

Questions.defaultProps = {
  selectedWorkspace: {},
  questions: {},
  fetchingQuestions: true,
  fetchedQuestions: true,
  getAllQuestions: noop,
};

export default Questions;
